import * as React from "react";
const ToolbarRootContext = /* @__PURE__ */ React.createContext(void 0);
if (process.env.NODE_ENV !== "production") ToolbarRootContext.displayName = "ToolbarRootContext";
function useToolbarRootContext(optional) {
  const context = React.useContext(ToolbarRootContext);
  return context;
}
export {
  ToolbarRootContext,
  useToolbarRootContext
};
//# sourceMappingURL=ToolbarRootContext.js.map
